import "../../../style/VideoGeneralPage/VideoGeneralPage.css"
import "../../../../common/UI/Modal/styles/modal.css"

import VIDEO from "../../../../common/assets/videos/VID-WlanBoxNg-ru.mp4";
import VIDEO2 from "../../../../common/assets/videos/VID-PulseNgCrash-ru.mp4";
import VIDEO3 from "../../../../common/assets/videos/Fairvideo_Spectra.mp4";

import PHOTO1 from "../../../../common/assets/images/Montronix/Video/PulseNG.png";
import PHOTO2 from "../../../../common/assets/images/Montronix/Video/Montronix-Wifi.png";
import PHOTO3 from "../../../../common/assets/images/Montronix/Video/SpectraNG.png";


import CIRCLE1 from "../../../../common/assets/images/Montronix/Video/CircleVIdeo1.svg";
import CIRCLE2 from "../../../../common/assets/images/Montronix/Video/CircleVIdeo2.svg";
import CIRCLE3 from "../../../../common/assets/images/Montronix/Video/CircleVIdeo3.svg";

import {useState, useEffect} from "react";
import {useStore} from "effector-react";
import {Modal} from "../../../../common/UI/Modal/molecules/Modal";
import {NavMenuMontronix} from "../../../../common/UI/NavMenu/organoids/NavMenuMontronix";
import {
    $GuideMode,
    $openModel,
    $ReadenVideoSlides,
    $videoChoise,
    AddReadenVideoSlide,
    clearVideoSlides,
    setOpenModel,
    setvideoChoise,
} from "../../../../common/UI/GuideButtons/logic/GuideLogic";
import {GuideButtons} from "../../../../common/UI/GuideButtons/organoids/GuideButtons";
import {IForModal} from "../../../../common/interfaces";
import {videoPointsWIFI} from "../atoms/VideoPoints_WIFI";
import {videoPointsPulseNG} from "../atoms/VideoPoints_PulseNG";
import {videoPointsSpectraNG} from "../atoms/VideoPoints_SpectraNG";

import {titleName} from "../../../../common/function";

export const VideoPageMontronix = () => {
    const [modalActive, setmodalActive] = useState(false);
    const [readenVideoSlidesNew, setreadenVideoSlidesNew] = useState(0);
    const [lengthVideoSlidesNew, setlengthVideoSlidesNew] = useState(10);
    const [forModal, setForModal] = useState<IForModal>({
        title: "",
        text: [''],
        titletext:[''],
        content: [""],
        maxWidthTable:"",
        minWidthTable:"",
        table: {
            tableheads: [{width: "", content: ""}],
            rows: [{title: "", showhead: true, columns: [], tableContent: [], tableText: []}],
        },
    });
    const [spreadMenu, setSpreadMenu] = useState<boolean>(false);
    // const onClick = (a:number) => {
    //     setvideoChoise(a)

    // }
    let points = videoPointsWIFI;
    const readenVideoSlides = useStore($ReadenVideoSlides);
    const videoChoise = useStore($videoChoise);
    const openModel = useStore($openModel);

    titleName("Montronix")

    useEffect(() => {
        if (videoChoise === 0) {
            points = videoPointsWIFI;
            setlengthVideoSlidesNew(videoPointsWIFI.length)
        } else if (videoChoise === 1) {
            points = videoPointsPulseNG;
            setlengthVideoSlidesNew(videoPointsPulseNG.length)
        } else {
            points = videoPointsSpectraNG;
            setlengthVideoSlidesNew(videoPointsSpectraNG.length)
        }
        
    }, [videoChoise, points])
    
    

    useEffect(() => {
        setreadenVideoSlidesNew(readenVideoSlides)
    }, [readenVideoSlides]);

    useEffect(() => {
        if ($GuideMode.getState()) {
            if (readenVideoSlidesNew === lengthVideoSlidesNew && modalActive === false) {

                setreadenVideoSlidesNew(0)

                if (videoChoise < 2)       //КОГДА БУДЕТ ПРИБАВЛЯТЬСЯ ВИДЕО НАДО ДОБАВИТЬ СЮДА +1 :)
                {
                    if (openModel === false) {
                        clearVideoSlides()
                    }
                    setvideoChoise(videoChoise + 1)
                } else
                    setOpenModel(true);

            }

        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [readenVideoSlides, lengthVideoSlidesNew, videoChoise, modalActive]);

    return (
        <div className="VideoPage">
            <div className="Page_BlockTitle">
                {videoChoise === 0 ? "WiFi BOX" : videoChoise === 1 ? "PulseNG" : "SpectraNG"}
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: 1,
                    width: "100%",
                }}
            >
                <video
                    src={videoChoise === 0 ? VIDEO : videoChoise === 1 ? VIDEO2 : VIDEO3}
                    className="videblock"
                    loop controls autoPlay muted
                    style={
                        spreadMenu
                            ? {
                                // transform: "translate(-20%, 0)",
                                transition: "0.5s",
                            }
                            : {transition: "0.5s"}
                    }
                />
                <GuideButtons
                    spreadMenu={spreadMenu}
                    setSpreadMenu={setSpreadMenu}
                    ReadenMarkers={readenVideoSlides}
                    AddReadenMarker={AddReadenVideoSlide}
                    markers={videoChoise === 0 ? videoPointsWIFI : videoChoise === 1 ? videoPointsPulseNG : videoPointsSpectraNG}
                    setForModal={setForModal}
                    setModalActive={setmodalActive}
                />
                <Modal
                    image={forModal.content}
                    active={modalActive}
                    setHover={setmodalActive}
                    points={null}
                    list={forModal.list}
                    title={forModal.title}
                    table={forModal.table}
                    text={forModal.text}
                    titletext={forModal.titletext}
                    maxWidthTable = {forModal.maxWidthTable}
                    minWidthTable = {forModal.minWidthTable}
                />
            </div>
            <NavMenuMontronix
                nextUrl={"/montronix/model"}
                backUrl={"/montronix/photo"}
                visibleFlag={"/montronix/video"}
            />
            <div className="button_video_all">
            <button
                    onClick={() => setvideoChoise(0)}
                    className={
                        videoChoise === 0
                            ? "button_video_choise borderNavMen"
                            : "visiblBlock button_video_choise"
                    }
                    style={{
                        textAlign: "center",

                    }}
                >
                    <div className="icon_2d_Video">
                        <img src={CIRCLE1} style={{height: "100%"}} alt=""/>
                    </div>
                    <img
                        src={PHOTO2}
                        style={{background: "50% 50% no-repeat"}}
                        alt=""
                    />
                </button>
                
                <button
                    onClick={() => setvideoChoise(1)}
                    className={
                        videoChoise === 1
                            ? "button_video_choise borderNavMen"
                            : "visiblBlock button_video_choise"
                    }
                    style={{
                        textAlign: "center",

                    }}
                >
                    <div className="icon_2d_Video">
                        <img src={CIRCLE2} style={{height: "100%"}} alt=""/>
                    </div>
                    <img
                        src={PHOTO1}
                        style={{background: "50% 50% no-repeat"}}
                        alt=""
                    />
                </button>
                <button
                    onClick={() => setvideoChoise(2)}
                    className={
                        videoChoise === 2
                            ? "button_video_choise borderNavMen"
                            : "visiblBlock button_video_choise"
                    }
                    style={{
                        textAlign: "center",

                    }}
                >
                    <div className="icon_2d_Video">
                        <img src={CIRCLE3} style={{height: "100%"}} alt=""/>
                    </div>
                    <img
                        src={PHOTO3}
                        style={{background: "50% 50% no-repeat"}}
                        alt=""
                    />
                </button>
                
            </div>
        </div>
    );
};
